export const STATESLIST = [
  "Kano",
  "Lagos",
  "Kaduna",
  "Katsina",
  "Oyo",
  "Rivers",
  "Bauchi",
  "Jigawa",
  "Benue",
  "Anambra",
  "Borno",
  "Delta",
  "Imo",
  "Niger",
  "Akwa Ibom",
  "Ogun",
  "Sokoto",
  "Ondo",
  "Osun",
  "Kogi",
  "Zamfara",
  "Enugu",
  "Kebbi",
  "Edo",
  "Plateau",
  "Adamawa",
  "Cross River",
  "Abia",
  "Ekiti",
  "Kwara",
  "Gombe",
  "Yobe",
  "Taraba",
  "Ebonyi",
  "Nasarawa",
  "Bayelsa",
  "Federal Capital Territory",
];
